/** @jsx jsx */
import { jsx } from "theme-ui"
import { useState } from "react"
import { InView } from "react-intersection-observer"

import Grid from "../../../atoms/Grid"
import GridRow from "../../../atoms/GridRow"
import AnimateInView from "../../../atoms/AnimateInView"
import SocialPostThumbnail from "../../../molecules/SocialPostThumbnail"

const SocialPosts = ({ children, as, posts, isMobile, ...otherProps }) => {
  const [isInView, setInView] = useState(false)
  const updateVisibility = inView => {
    setInView(inView)
  }

  return (
    <InView
      as={Grid}
      onChange={inView => updateVisibility(inView)}
      threshold={0.1}
      triggerOnce
      sx={{
        gridTemplateColumns: [
          "repeat(8, 1fr)",
          "repeat(8, 1fr)",
          "repeat(20, 1fr)",
        ],
        gridColumn: ["1 / -1", "3 / -3"],
      }}
      {...otherProps}
    >
      {posts.map((node, i) => {
        const {
          livePost: { thumbnail_url, description, url, author, provider_name },
        } = node

        return (
          <GridRow.Col key={node.id} gridSpan={[8, 4, 5]} sx={{ mb: 7 }}>
            <AnimateInView y="70px" delay={isMobile ? "0s" : `${i * 0.1}s`}>
              <SocialPostThumbnail
                to={url}
                imageUrl={thumbnail_url}
                subtitle={description}
                author={author}
                provider={provider_name}
                width={380}
                height={380}
                preload={isInView}
              />
            </AnimateInView>
          </GridRow.Col>
        )
      })}
    </InView>
  )
}

export default SocialPosts
